<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nDncOl/tc-custom/9781429968812.jpg?1728851543110" alt="This image is the cover for the book To Try Men's Souls, George Washington Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">To Try Men's Souls, George Washington Series
      </h1>
      <p class="bookDescription body article font2">
        <b>This biographical novel exploring America’s Revolutionary Era is “surely to become another popular book” for the <i>New York Times</i>–bestselling authors.</b><br/><br/>The story follows three men with three very different roles to play in history: General George Washington, Thomas Paine, and Jonathan Van Dorn, a private in Washington’s army.<br/><br/>The action focuses on one of the most iconic events in American history: Washington crossing the Delaware. Unlike the bold, courageous General in Emanuel Leutze’s painting, Washington is full of doubt on the night of December 25, 1776. After five months of defeat, morale is dangerously low. Each morning muster shows that hundreds have deserted in the night.<br/><br/>While Washington prepares his weary troops for the attack on Trenton, Thomas Paine is in Philadelphia, overseeing the printing of his newest pamphlet, The Crisis.<br/><br/>And Jonathan Van Dorn is about to bring the war to his own doorstep. In the heat of battle, he must decide between staying loyal to the cause and sparing his brother who has joined up with the British. Through the thoughts and private fears of these three men, Gingrich and Forstchen illuminate the darkest days of the Revolution. With detailed research and an incredible depth of military insight, <i>To Try Men’s Souls</i> is a novel that provides a rare and personal perspective of the men who fought for, and founded the United States of America.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Newt Gingrich, William R. Forstchen
      </h2>
      
      <p class="authorDescription body article"><P><B>NEWT GINGRICH</B>, front-running Republican primary candidate for the 2012 Presidential Election, former Speaker of the House, bestselling author of<I>Gettysburg</I> and <I>Pearl Harbor</I>, the longest serving teacher of the Joint War Fighting Course for Major Generals at Air University, and an honorary Distinguished Visiting Scholar and Professor at the National Defense University. He resides in Virginia with his wife, Callista, with whom he hosts and produces documentaries, including their latest, "A City Upon A Hill". <br><br><B>WILLIAM R. FORSTCHEN, PH.D.</B>, is a Faculty Fellow at Montreat College and is the author of more than 40 books, including the <I>New York Times</I> bestseller <I>One Second After</I> and <I>We Look Like Men of War</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Dunne Books St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e055b74